/* control.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./control.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */

import { cx } from '@compiled/react';
import { getStyleProps } from '../../utils';
var styles = {
  default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123byq51 _d0altlke _irr31d5g _1ogl1caj",
  compact: "_1tkezwfg",
  invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
  focusedInvalid: "_16qsq049",
  disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
  focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
  subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
  subtleFocused: "_bfhkvuon",
  none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
export var css = function css() {
  return {};
};
var Control = function Control(props) {
  var children = props.children,
    appearance = props.appearance,
    isCompact = props.isCompact,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isInvalid = props.isInvalid,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen,
    xcss = props.xcss;
  var _getStyleProps = getStyleProps(props, 'control', {
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }),
    css = _getStyleProps.css,
    className = _getStyleProps.className;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    ,
    className: ax([styles.default, isDisabled && styles.disabled, isInvalid && styles.invalid, isCompact && styles.compact, appearance === 'subtle' && styles.subtle, appearance === 'subtle' && isFocused && styles.subtleFocused, isFocused && styles.focused, appearance === 'none' && styles.none, cx(className, xcss, '-control')])
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: css
  }, innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Control;